<template>
  <div>
    <a-modal title="课程开课通知 > 预报名" :maskClosable="false" :width="1300" :visible="visible"
      :confirmLoading="confirmLoading" @cancel="handleCancel" :footer="false" :destroyOnClose="true">
      <div class="class-list">
        <!-- 搜索 -->
        <div class="search-inner">
          <a-form layout="inline">
            <a-form-item class="name" label="姓名">
              <a-input class="form-cell" type="text" placeholder="请输入" v-model="queryParam.studentName"></a-input>
            </a-form-item>

            <a-form-item class="name" label="学号">
              <a-input class="form-cell" type="text" placeholder="请输入" v-model="queryParam.studentNumber"></a-input>
            </a-form-item>
            <a-form-item label="年级">
              <a-select class="form-cell" placeholder="请选择" v-model="queryParam.gradeId">
                <a-select-option v-for="(item, index) in $store.getters.getGradeScope" :key="index" :value="item.id">{{
                  item.tagName }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item class="name" label="原始班级">
              <a-select class="form-cell" placeholder="请选择" v-model="queryParam.originalClassId">
                <a-select-option v-for="(item, index) in classList" :key="index" :value="item.id">{{ item.className
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item class="search-oper">
              <a-button class="search" type="primary" @click="searchStudent()">查询</a-button>
              <a-button type="primary" @click="() => (queryParam = {})">重置</a-button>
            </a-form-item>
          </a-form>
        </div>
        <div class="new-build">
          <a-button type="primary" @click="$refs.newForecastProject.init(classId)">+ 新建</a-button>
        </div>
        <!-- 表格数据 -->
        <a-table rowKey="id" :columns="columns" :dataSource="studentList" disabled="true" :loading="loading"
          :pagination="false">
          <span slot="gradeId" slot-scope="text, record">
            <template>
              <span>{{ record.gradeId | gradeScopeFilter }}</span>
            </template>
          </span>
          <span slot="gender" slot-scope="text, record">
            <template>
              <span>{{ record.gender | gender }}</span>
            </template>
          </span>
          <span slot="orderNo" slot-scope="text, record">
            <template>
              {{ record.orderNo }}
              <a-popover arrow-point-at-center placement="bottom" v-if="record.orderType">
                <template slot="title">
                  <p><b>{{ record.orderType == 1 ? '订单' : '账单' }}</b></p>
                </template>
                <template slot="content">
                  <p>课时费：￥{{ record.coursePrice / 100 || 0}}</p>
                  <p>教材教具：￥{{ record.textBookPrice / 100 || 0}}</p>
                  <p v-if="record.orderType == 1">教材教具：{{ record.hasTextbook ? '已选' : '未选' }}</p>
                  <p>备注： {{ record.remark || '无' }}</p>
                </template>
                <a><a-icon class="icon-circle" type="question-circle" /></a>
              </a-popover>
            </template>
          </span>
          <span slot="tradeTime" slot-scope="text, record">
            <template>
              <div>{{ record.tradeTimeStart }}~</div>
              <div>{{ record.tradeTimeExpire }}&nbsp;&nbsp;</div>
            </template>
          </span>
          <span slot="operate" slot-scope="text, record">
            <template>
              <a class="cut-off" @click="cutOff(record.id)">删除</a>
            </template>
          </span>
        </a-table>
        <!-- 分页栏显示总数 -->
        <div style="margin-top: 16px;float: right;" v-if="studentList.length">
          <a-pagination :total="studentList.length" :show-total="total => `总共 ${total} 条`" :default-current="1"
            :pageSize="1000" />
        </div>
      </div>
      <a-modal :closable="false" title="未查询到的学生或学号" :maskClosable="false" :width="400" :visible="barrenVisible"
        :confirmLoading="confirmLoading">
        <template slot="footer">
          <a-button type="primary" key="back" @click="barrenVisible = false">
            确定
          </a-button>
        </template>
        <span v-for="(item, index) in barrenList" :key="index">{{ item }}</span>
      </a-modal>
    </a-modal>
    <new-forecast-project @freshen="freshen" ref="newForecastProject"></new-forecast-project>
  </div>
</template>

<script>
import student from '../../../api/student'

import classSet from '../../../api/classSet'

import sourceClass from '../../../api/sourceClass'

import moment from 'moment'

import NewForecastProject from './ForecastProject'

import Vue from 'vue'

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 80,
  },
  {
    title: '姓名',
    dataIndex: 'studentName',
    width: 100
  },
  {
    title: '性别',
    dataIndex: 'gender',
    scopedSlots: { customRender: 'gender' },
    width: 40,
  },
  {
    title: '生日',
    dataIndex: 'birthday',
    width: 90,
  },
  {
    title: '学号',
    dataIndex: 'studentNumber',
    width: 90,
  },
  {
    title: '年级',
    dataIndex: 'studentGrade',
    scopedSlots: { customRender: 'studentGrade' },
    width: 90,
  },
  {
    title: '原始班级',
    dataIndex: 'originalClass',
    width: 130,
  },
  {
    title: '家长手机号',
    dataIndex: 'mobile',
    width: 105,
  },
  {
    title: '订单号',
    dataIndex: 'orderNo',
    scopedSlots: { customRender: 'orderNo' },
    width: 115,
  },
  {
    title: '付款时间',
    scopedSlots: { customRender: 'tradeTime' },
    width: 180,
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    width: 95,
    sorter: (a, b) => new Date(a.gmtCreate).getTime() - new Date(b.gmtCreate).getTime(),
  },
  {
    title: '操作',
    dataIndex: 'operate',
    scopedSlots: { customRender: 'operate' },
    width: 60,
  },
]
export default {
  name: "insertClass",
  data() {
    return {
      moment,
      columns,
      visible: false,
      confirmLoading: false,
      studentList: [],
      selectedStudent: [],
      classId: "",
      pagination: {
        showTotal: (total) => `总共 ${total} 条`,
        current: 1,
        pageSize: 100,
        total: 0,
        pageSizeOptions: ["10", "20", "30", "50", "70", "100"],
        showLessItems: true,
        showSizeChanger: true,
      },
      loading: false,
      queryParam: {},
      classList: [],
      barrenVisible: false,
      barrenList: [],
      schoolId: Vue.ls.get('schoolId'),
    };
  },
  methods: {
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地址的话，把地址解析之后带入
      let obj = this.queryParam;
      obj.currentPage = pagination.current;
      obj.pageSize = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${sorter.order == "ascend" ? "asc" : "desc"}`;
      }
      this.getClassList(obj);
    },
    //提交
    handleSubmit() {
      if (this.selectedStudent.length == 0) {
        this.$message.warn("请选择学生");
        return;
      }
      let req = {
        classId: this.classId,
        studentIds: this.selectedStudent.join(),
      };
      classSet.joinClass(req).then((res) => {
        this.$message.success("插班成功");
        this.$emit("refreshList", res.data);
        this.handleCancel();
      });
    },
    //table选中事件
    onSelectChange(selectedRowKeys, value) {
      this.selectedStudent = [];
      value.map((item) => {
        this.selectedStudent.push(item.id);
      });
    },
    freshen(data) {
      console.log(data, '子的数据传过来了吗235')
      this.searchStudent()
      // this.reload();
    },
    // 查询删除操作
    cutOff(data) {
      console.log(data, '删除ID操作')
      student.deleteStudentList(
        data
      ).then((res) => {
        console.log('删除成功了吗')
        this.searchStudent();
      })
    },
    //初始化，显示
    init(id) {
      console.log(11, id);
      this.visible = true;
      this.classId = id;
      this.queryParam = {};
      // this.getClassList();
      // 初始化原始班级的下拉列表
      this.searchOriginalClass(this.schoolId);
      //下拉班级列表
      student.getPreRegistrationList().then((res) => {
        // this.classList = res.data
        console.log(this.classId.id, 'classIdclassId')
      });
      this.searchStudent();
    },
    //隐藏
    handleCancel() {
      this.pagination.pageSize = 100;
      this.visible = false;
      this.$emit("closeForm");
    },
    //查询学生
    searchStudent() {
      setTimeout(() => {
        this.getClassList(this.queryParam);
      }, 100)
      console.log(this.queryParam, 'queryParam这个内容是啥')
    },
    async searchOriginalClass(id) {
      const result = await sourceClass.getOriginalClassList(
        { id: id }
      )
      this.classList = result.data.list
      console.log(result, '原始班级是啥', this.classList, 'classList是啥玩意')

    },
    //获取班级列表
    getClassList(req = {}) {
      this.loading = true;
      console.log("req123", req);
      console.log("判断了是什么", isNaN(Number(req.studentNumber)));
      if (req.studentNumber) {
        if (!isNaN(Number(req.studentNumber))) {
          req.studentNumber = Number(req.studentNumber);
        } else {
          req.studentNumber = req.studentNumber;
        }
      }
      req.classId = this.classId.id
      console.log(req, 'reqreqreqrq')
      student
        .getPreOrderList({
          ...req,
        })
        .then((res) => {
          console.log("res", res);
          if (res.data.noSearchStudentNameOrNumber) {
            this.barrenVisible = true;
            this.barrenList = res.data.noSearchStudentNameOrNumber;
          }
          this.studentList = res.data;

          this.loading = false;
        });
    },
  },
  components: { NewForecastProject }
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.class-list {
  height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: hidden;

  .oper {
    text-align: right;
    margin-bottom: 10px;

    >.export {
      margin-left: 10px;
    }
  }
}

.class-cell {
  font-size: 14px;
  color: $normal-color-dark;
  line-height: 26px;
}

.tab-active {
  color: $primary-color;
}

.tab-list {
  border-bottom: 1px solid $border-color;
  padding: 0px 0px 10px;
  margin-bottom: 20px;

  >.tab {
    display: inline-block;
    margin-right: 30px;
    font-size: 16px;
  }
}

.search-inner {
  margin-bottom: 10px;
}

.search-oper {
  .search {
    margin-right: 10px;
  }
}


.search-inner ::v-deep .ant-form-item-control {
  width: 150px;
}

.search-inner ::v-deep .ant-form-item-children {
  width: 150px;
}

.search-inner ::v-deep .ant-input {
  width: 150px;
}

.search-inner ::v-deep .form-cell {
  width: 150px;
}

.class-list ::v-deep .ant-table-header-column {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.class-list ::v-deep .ant-table-row-cell-break-word {
  vertical-align: middle;
  text-align: center;
}

.new-build {
  margin-bottom: 15px;
}

.cut-off {
  color: RGB(73 149 274);
}
</style>
